var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconFacebookMessenger = function SvgIconFacebookMessenger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#448AFF",
    d: "M24 4C13.5 4 5 12.1 5 22c0 5.2 2.3 9.8 6 13.1V44l7.8-4.7c1.6.4 3.4.7 5.2.7 10.5 0 19-8.1 19-18S34.5 4 24 4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m12 28 10-11 5 5 9-5-10 11-5-5z"
  })));
};
export default SvgIconFacebookMessenger;